<div mat-dialog-content>
  <div class="text-center">
    <div class="i-circle danger">
      <i *ngIf="!alternativeIcon" class="fas fa-exclamation-triangle"></i>
      <i *ngIf="alternativeIcon"  class="fas fa-exclamation" style='color: rgb(0, 132, 214)'></i> 
     
    </div>
    <h4 style="color: rgb(var('textcolor[0]'),var('textcolor[1]'),var('textcolor[2]'))" class="color-default" 
    [ngClass]="textClassAlign ? textClassAlign : null"  [innerHtml]="(text | translate)" 
    *ngIf="text"></h4>
  </div>
  <div [innerHtml]="subtext | safeHtml" *ngIf="subtext"></div>

</div>
<div mat-dialog-actions>
  <div class="full-width text-right">
    <button type="button" class="btn btn-danger" title="{{'NO' | translate}}" (click)="dialogRef.close(false)">
      <i class="fas fa-times"></i>&nbsp;{{'NO' | translate}}
    </button>
    <button type="button" class="btn btn-success" title="{{'YES' | translate}}" (click)="dialogRef.close(true)">
      <i class="fas fa-check"></i>&nbsp;{{'YES' | translate}}
    </button>
  </div>
</div>